import React from 'react';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

import { Auth } from './core/auth';
import { AppState } from './core/redux/reducers';
import { GoogleAuth, Header, Menu } from './features';
import { Routes } from './Routes';
import { history } from './utils';

interface StateToProps {
  auth: Auth;
}

class AppComponent extends React.Component<StateToProps> {
  renderAuthenticatedApp() {
    return (
      <Router history={history}>
        <Menu />
        <Wrapper>
          <Container>
            <ToastContainer autoClose={3000} />
            <Header />
            <Content>
              <Routes />
            </Content>
          </Container>
        </Wrapper>
      </Router>
    );
  }

  renderUnauthenticatedApp() {
    return (
      <div className='ui two column centered grid'>
        <div className='column'>
          <div style={{ textAlign: 'center', padding: '1em' }}>
            <div className='ui center aligned header'>
              Acessar Dashboard Favid
              </div>
            <GoogleAuth />
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.props.auth.isSignedIn) {
      return this.renderAuthenticatedApp();
    }

    return this.renderUnauthenticatedApp();
  }
}

const mapStateToProps = ({ auth }: AppState): StateToProps => {
  return { auth };
};

export const App = connect(mapStateToProps)(AppComponent);

const Wrapper = styled.div`
  padding-left: 15em;
  display: flex;
  width: 100%;
  justify-content: center;
`;

const Container = styled.div`
  padding: 1em;
  max-width: 1000px;
  width: 100%;
`;

const Content = styled.div`
  padding: 1em;
`;
